import styled from 'styled-components';

export const Tag = styled.div`
  vertical-align: super;
  padding-left: 3px;
  font-size: 8pt;
  display: inline-block;
  font-weight: bold;
`;
